import { EObjectType, IJsonQuery, terms } from '../../../utils/jsonQuery';

export const defaultState: IJsonQuery = {
  _type: 'suburbansale',
  engine_version: { type: 'term', value: 2 },
  object_type: terms([EObjectType.House, EObjectType.Housepart, EObjectType.Townhouse, EObjectType.Land]),
};
